export interface SalesInvoiceHeaderExtraItem {
  id: string;
  salesInvoiceHeaderId: string;
  productId: string;
  productKey: string;
  productDescription: string;
  quantity: number;
  price: number;
  notes: string;
}
